import Money from 'common/components/layout/Money';

const CompareAtPrice = (props) => {
  const { product, settings } = props;
  if (!product.variants) {
    return null;
  }
  const multiplier = product.type === 'Wine' ? 12 : 1;
  const variant = product.variants[0];
  if (!variant) {
    return null;
  }
  const price = variant.comparePrice || variant.price;
  if (!variant.addToCartPrice || variant.addToCartPrice >= price) {
    // This is the regular price - classname c7-product__variant-price
    return (
      <div className="c7-product__variant__price__normal">
        <Money number={price * multiplier} settings={settings} />
      </div>
    );
  }
  // TODO change class name to be compareAt price with strike-thru on it.  c7-product__variant-compare-at-price
  return (
    <div className="c7-product__variant__price__compare">
      <Money number={price * multiplier} settings={settings} />
    </div>
  );
};

export default CompareAtPrice;
